import { PAYMENT_METHODS, SERVICES } from '@autopass-web/domain';

import Client from '../../client';
import { creditCard3dValidation } from './3d-vaildation';

import type { PaymentInfo, Receipt } from '../types';

interface CreateCreditCardSessionProps {
  paymentInfo: PaymentInfo;
  receipt: Receipt;
  email: string | undefined;
  cardInfo: {
    number: string;
    exp: string;
    cvc: string;
  };
}

export const createCreditCardSession = async ({
  paymentInfo,
  receipt,
  email,
  cardInfo: { number, exp, cvc },
}: CreateCreditCardSessionProps) => {
  const { data } = await Client.createCreditCardSession({
    parkingTicketId: paymentInfo.id,
    email,
    receipt,
  });

  const transactionId = data.data.id;

  const callbackUrlParams = new URLSearchParams({
    paymentType: PAYMENT_METHODS.CREDIT_CARD,
    serviceType: SERVICES.APS,
    createTransactionId: transactionId,
    parkingTicketId: paymentInfo.id,
    plateNumber: paymentInfo.plateNumber,
  });

  const callbackUrl = `${
    window.location.origin
  }/auth?${callbackUrlParams.toString()}`;

  creditCard3dValidation({
    serviceType: SERVICES.APS,
    cardNumber: number,
    cardExpireDate: exp,
    cardCvc: cvc,
    amount: paymentInfo.amount,
    merchantUid: paymentInfo.merchantUid,
    orderType: 'parking_order',
    transactionType: 'parking',
    callbackUrl,
  });
};
